import { requestHeaderWithAccessToken, serverUrl } from "../auth/auth.service"
import { AccountModel } from "./account.model";

export async function saveAccount(Account: AccountModel): Promise<number> {
  try {
    const response = await fetch(serverUrl + `person/accounts/save`,
      {
        method: "POST",
        headers: requestHeaderWithAccessToken(),
        body: JSON.stringify(Account)
      }
    );
    //console.log("saveAccount: ", await response);
    if (response.ok) return response.json();
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}
